"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MiniBagConfigurationProps = require("./MiniBagConfigurationProps");
Object.keys(_MiniBagConfigurationProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MiniBagConfigurationProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MiniBagConfigurationProps[key];
    }
  });
});
var _MiniBagWrapperProps = require("./MiniBagWrapperProps");
Object.keys(_MiniBagWrapperProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MiniBagWrapperProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MiniBagWrapperProps[key];
    }
  });
});
var _TestIdProp = require("./TestIdProp");
Object.keys(_TestIdProp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TestIdProp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TestIdProp[key];
    }
  });
});
